import { render, staticRenderFns } from "./extraReceptionPrice.vue?vue&type=template&id=4225f358"
import script from "./extraReceptionPrice.vue?vue&type=script&lang=js"
export * from "./extraReceptionPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4225f358')) {
      api.createRecord('4225f358', component.options)
    } else {
      api.reload('4225f358', component.options)
    }
    module.hot.accept("./extraReceptionPrice.vue?vue&type=template&id=4225f358", function () {
      api.rerender('4225f358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/components/extraReceptionPrice.vue"
export default component.exports